import React, { useEffect, useState } from "react";
import { searchableSelectClass } from "./MyConstants";
import { useDispatch, useSelector } from "react-redux";
import { ChevronDown, User, X } from "lucide-react";
import { HitApi } from "../../Api/ApiHit";
import { setApiJson } from '../../redux/Actions/ApiAction';
import AppButton from "../AppButton/AppButton";
import CustomModal from "../CustomModal/CustumModal";
import AppInput from "../AppInput/AppInput";
import { addClient, searchUser, searchAttendance } from "../../constant/Constant";
import { getSelectedUnit } from "../../storage/Storage";
import toast from "react-hot-toast";
import SearchableSelect from "../AppSelect/SearchableSelect";
import { getOptionsWithFallback } from "../../utils/generalOptionsUtils";
import { ageGroupOptions, customerTypeOptions, genderOptions } from "../../constant/Options";

const MySearchableSelect = ({ className, onChange, disable, title, important, name, error, errorMsg, placeholder, api, optionLable, optionValue, onSelect, parent, value, extraSearch, serviceIndex, stepIndex, productIndex, giveFullElement, clientSelect }) => {

    const ApiReducer = useSelector((state) => state.ApiReducer);
    const [option, setOption] = useState([]);
    const [optionShow, setOptionShow] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [modal, setModal] = useState(false);
    const [genderOptionsFromApi, setGenderOptionsFromApi] = useState([]);
    const BillingReducer = useSelector((state) => state.BillingReducer);

    const [ageGroupOptionsFromApi, setAgeGroupOptionsFromApi] = useState([]);


    const dispatch = useDispatch();
    const getUnit = getSelectedUnit()

    // Debug: Log when component receives extraSearch prop
    useEffect(() => {
        console.log('=== MySearchableSelect Props ===');
        console.log('title:', title);
        console.log('extraSearch received:', extraSearch);
        console.log('================================');
    }, [extraSearch, title]);


    useEffect(() => {
        if (inputValue !== '' && BillingReducer?.clientInfo === null && clientSelect) {
            setInputValue('')
        }
        if (api && inputValue === "") fetchData("", optionLable);
        if (value) {
            setInputValue(value);
            if (name && !ApiReducer?.apiJson?.[name]) {
                const newJson = { ...ApiReducer.apiJson };
                newJson[name] = value;
                dispatch(setApiJson(newJson));
            }
        }
    }, [modal, BillingReducer]);

    // Refetch data when extraSearch changes
    useEffect(() => {
        if (api && extraSearch) {
            console.log('extraSearch changed, refetching...', extraSearch);
            fetchData("", optionLable);
        }
    }, [extraSearch]);


    const fetchData = async (val, type) => {

        const json = {
            page: 1,
            limit: 5,
            search: {}
        };

        if (extraSearch) json.search = { ...extraSearch };
        if (val && type) json.search[type] = val;

        console.log('=== MySearchableSelect fetchData ===');
        console.log('extraSearch:', extraSearch);
        console.log('Final search JSON:', JSON.stringify(json, null, 2));
        console.log('API endpoint:', api);
        console.log('====================================');

        try {
            const res = await HitApi(json, api);
            let options = [];

            if (res?.data?.docs?.length) {
                options = res.data.docs;
            }
            else if (res?.data?.length) {
                options = res.data;
            }

            // If fetching users/staff, also fetch attendance data and merge
            if (api === searchUser && options.length > 0) {
                const today = new Date();
                const startDate = new Date(today);
                startDate.setHours(0, 0, 0, 0);

                const endDate = new Date(today);
                endDate.setHours(23, 59, 59, 999);

                const attendanceJson = {
                    page: 1,
                    limit: 100,
                    search: {
                        unitIds: getSelectedUnit()?._id,
                        created: {
                            $gte: startDate.toISOString(),
                            $lte: endDate.toISOString()
                        }
                    }
                };

                const attendanceRes = await HitApi(attendanceJson, searchAttendance);

                if (attendanceRes?.statusCode === 200) {
                    const attendanceData = Array.isArray(attendanceRes?.data?.docs) ? attendanceRes.data.docs : [];

                    // Group attendance by userId and get latest record
                    const userAttendanceMap = new Map();
                    attendanceData.forEach(attendance => {
                        const userId = attendance.userId?._id;
                        if (userId) {
                            if (!userAttendanceMap.has(userId)) {
                                userAttendanceMap.set(userId, []);
                            }
                            userAttendanceMap.get(userId).push(attendance);
                        }
                    });

                    // Merge attendance info into user objects
                    options = options.map(user => {
                        const userAttendances = userAttendanceMap.get(user._id);
                        if (userAttendances && userAttendances.length > 0) {
                            // Get latest attendance record
                            const sortedAttendances = userAttendances.sort((a, b) =>
                                new Date(b.modified || b.created) - new Date(a.modified || a.created)
                            );
                            const latestAttendance = sortedAttendances[0];

                            // Only add attendance info if staff has punched in today
                            if (latestAttendance.punchInTime &&
                                (user.userType === "Staff" || user.userType === "staff" || user.userType === "STAFF")) {
                                return {
                                    ...user,
                                    attendanceInfo: {
                                        punchInTime: latestAttendance.punchInTime,
                                        punchOutTime: latestAttendance.punchOutTime,
                                        status: latestAttendance.status
                                    }
                                };
                            }
                        }
                        return user;
                    });
                }
            }

            setOption(options);
        } catch (error) {
            console.error('Error fetching data:', error);
            setOption([]);
        }
    };

    const handleInputChange = (e) => {
        const val = e.target.value;
        const newJson = { ...ApiReducer.apiJson };

        if (/^\d+$/.test(val)) {
            // Only digits (number)
            newJson["phoneNumber"] = val;
            console.log("val--number wali", val);
        } else {
            newJson["name"] = val;
            console.log("val--name wali", val);
        }
        dispatch(setApiJson(newJson));
        setInputValue(val);
        // Search is now triggered only on Enter key press
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const val = inputValue;
            if (val && val.trim().length >= 3) {
                fetchData(val, /^\d+$/.test(val) ? 'phoneNumber' : optionLable);
            } else if (val && val.trim().length < 3) {
                toast.error('Please enter at least 3 characters to search');
            }
        }
    };


    const onSelectOption = (val) => {
        if (onChange) onChange(val);
        console.log('val', val);


        setOptionShow(false);
        setInputValue(giveFullElement ? val?.[optionLable] : val);
        if (onSelect) {
            if (typeof serviceIndex === 'number') {
                onSelect(val, serviceIndex, stepIndex, productIndex);
                console.log('number', val);
            } else {
                onSelect(val);
                console.log('callval', val);
            }
        } else if (name) {
            console.log('call');

            const newJson = { ...ApiReducer.apiJson };
            if (parent) {
                const parentObj = { ...(newJson[parent] || {}) };
                parentObj[name] = val;
                newJson[parent] = parentObj;
            } else {
                newJson[name] = val;
            }
            dispatch(setApiJson(newJson));
        }
    };
    const handelClient = () => {
        setModal(true)
    }
    const AddClient = () => {
        const json = {
            phoneNumber: ApiReducer?.apiJson?.phoneNumber,
            name: ApiReducer?.apiJson?.name,
            ageGroup: ApiReducer?.apiJson?.ageGroup,
            customerType: ApiReducer?.apiJson?.customerType,
            gender: ApiReducer?.apiJson?.gender,
            unitIds: getUnit?._id
        };
        const { name, phoneNumber, ageGroup, gender, customerType } = ApiReducer?.apiJson || {};

        if (!name?.trim()) {
            toast.error("Name cannot be empty");
        } else if (!/^\d{10}$/.test(phoneNumber || "")) {
            toast.error("Phone number must be exactly 10 digits");
        }
        else if (!ageGroup?.trim()) {
            toast.error("Age group is required");
        } else if (!gender?.trim()) {
            toast.error("Gender is required");
        }
        else if (!customerType?.trim()) {
            toast.error("Customer type is required");
        } else {
            HitApi(json, addClient).then((res) => {
                console.log("res", res);
                if (res?.statusCode === 201) {
                    setModal(false);
                    if (onChange) onChange(res?.data);
                    setOptionShow(false);
                    toast.success("Client added successfully");
                }
            });
        }






    }


    console.log("BillingReducer", BillingReducer);


    return (
        <div>
            <p className='w-full text-black'> {title} {important && <span className='text-red-600 text-base'>*</span>}</p>
            <div className="relative w-full">
                <div className={`${disable ? 'bg-gray-200' : ''} ${searchableSelectClass} flex items-center ${className || ''}`} onClick={() => !disable && setOptionShow(!optionShow)}>
                    <input
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        placeholder={placeholder}
                        disabled={disable}
                        className="w-full border-none bg-transparent focus:outline-none focus:ring-0"
                    />
                    <div className="mr-1"><ChevronDown size={18} /></div>
                </div>
                {optionShow && (
                    <div className="absolute z-50 bg-white shadow-lg p-2 w-full max-h-60 overflow-y-auto mt-1">
                        {
                            option.length > 0 ? option.map((ele, i) => {
                                // Check if this is a staff member with attendance info
                                const hasPunchedOut = ele?.attendanceInfo?.punchOutTime;
                                const statusDot = ele?.attendanceInfo ? (hasPunchedOut ? '🔴' : '🟢') : '';
                                const displayText = statusDot ? `${statusDot} ${ele?.[optionLable]}` : ele?.[optionLable];

                                return (
                                    <p key={i} onClick={() => onSelectOption(giveFullElement ? ele : ele?.[optionLable])} className="hover:bg-gray-100 p-1 cursor-pointer">
                                        {displayText}
                                    </p>
                                );
                            })
                                :
                                clientSelect ?
                                    <AppButton onClick={handelClient} buttontext={"Add Client"} /> : <p className="text-gray-400">No data found!</p>
                        }
                    </div>
                )}
            </div>
            <p className='w-full text-red-600'>
                {error && errorMsg ? errorMsg : ApiReducer.apiJsonError?.[name] ? `${title} is Required` : ''}
            </p>
            {
                <div>
                    <CustomModal isOpen={modal} size="lg" onClose={() => setModal(false)}>
                        <div className="p-5">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-2xl font-bold mb-4 ">Add New Client</h2>
                                <X className="cursor-pointer" onClick={() => setModal(false)} />
                            </div>
                            {/* Add your form fields here */}

                            <div className="mt-4 space-y-3">
                                <div className="text-left">
                                    <AppInput
                                        title="Full Name"
                                        placeholder="Enter full name"
                                        name="name"
                                        important={true}
                                        value={ApiReducer?.apiJson?.name || ''}
                                        icon={<User size={18} />}
                                        str
                                    />
                                    <AppInput
                                        title="Contact Number"
                                        value={ApiReducer?.apiJson?.phoneNumber || ''}
                                        placeholder="Enter contact number"
                                        name="phoneNumber"
                                        num
                                    />
                                    <SearchableSelect
                                        title="Age Group"
                                        name="ageGroup"
                                        options={getOptionsWithFallback(ageGroupOptionsFromApi, ageGroupOptions)}
                                        important={false}
                                        placeholder="Select age group"
                                    />
                                    <SearchableSelect
                                        title="Gender"
                                        name="gender"
                                        options={getOptionsWithFallback(genderOptions)}
                                        important={false}
                                        placeholder="Select gender"
                                    />
                                    <SearchableSelect
                                        title="Customer Type"
                                        name="customerType"
                                        options={getOptionsWithFallback(customerTypeOptions)}
                                        important={false}
                                        placeholder="Select gender"
                                    />
                                    <AppButton onClick={AddClient} buttontext={"Add Client"} />
                                </div>
                                <div className="flex space-x-2">
                                </div>
                            </div>

                        </div>
                    </CustomModal>
                </div>
            }
        </div>
    );
};

export default MySearchableSelect;
